import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Accordion from 'shared/components/Accordion/Accordion';
import leasingFaqData from 'shared/data/json/leasingFaq.json';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LeasingFaq.css';

class LeasingFaq extends React.Component {
  static propTypes = {
    rows: PropTypes.number,
    locale: PropTypes.string.isRequired,
  };
  static defaultProps = {
    rows: 2,
  };
  render() {
    const { rows, locale } = this.props;
    const titleKey = locale === 'ru' ? 'title' : `title_${locale}`;
    const htmltKey = locale === 'ru' ? 'html' : `html_${locale}`;

    const items = leasingFaqData.map(item => ({
      title: item[titleKey],
      html: item[htmltKey],
    }));

    return (
      <div className={s.root}>
        <Accordion rows={rows} items={items} />
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  locale: globals.locale,
  location: globals.location,
});

export default withStyles(s)(connect(mapStateToProps)(LeasingFaq));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingFaq/LeasingFaq.js